import React, { useState } from "react";
import { Plus, X } from "lucide-react";
import { AccessMethodIcon } from "../shared/AccessMethodIcon";

/** Editor de las formas de acceso (proveedores de login) configuradas por juego. */
export function AccessMethodsEditor({ methods, onChange }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (methods.some((m) => m.toLowerCase() === v.toLowerCase())) { setDraft(""); return; }
    onChange([...methods, v]);
    setDraft("");
  };

  return (
    <div className="p-3 rounded-xl bg-ag7-bg border border-[var(--ag7-border-soft)] space-y-2" data-testid="access-methods-editor">
      <label className="block text-xs font-mono text-zinc-400 uppercase tracking-wider">Formas de acceso disponibles</label>
      <div className="flex flex-wrap gap-2" data-testid="access-methods-list">
        {methods.length === 0 && <span className="text-[10px] text-zinc-500">Sin métodos aún. Ej.: Activision, Google, Facebook.</span>}
        {methods.map((m) => (
          <span key={m} data-testid={`access-method-chip-${m.split(" ")[0].toLowerCase()}`}
            className="inline-flex items-center gap-1.5 pl-2.5 pr-1.5 py-1 rounded-full bg-ag7-purple/20 border border-ag7-purple/50 text-[11px] font-bold text-white">
            <AccessMethodIcon name={m} className="w-3 h-3" />
            {m}
            <button type="button" onClick={() => onChange(methods.filter((x) => x !== m))}
              data-testid={`access-method-remove-${m.split(" ")[0].toLowerCase()}`}
              className="w-4 h-4 rounded-full hover:bg-white/15 inline-flex items-center justify-center" aria-label={`Quitar ${m}`}>
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input value={draft} onChange={(e) => setDraft(e.target.value)} maxLength={40}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          data-testid="access-method-input" placeholder="Ej. EA, Google, Facebook…"
          className="flex-1 min-w-0 bg-ag7-surface border border-[var(--ag7-border-soft)] rounded-xl px-3 py-2 text-xs font-mono text-white focus:outline-none focus:border-ag7-purple" />
        <button type="button" onClick={add} disabled={!draft.trim()} data-testid="access-method-add-btn"
          className="flex-shrink-0 px-3 py-2 rounded-xl bg-ag7-purple hover:bg-ag7-purple/80 disabled:opacity-40 text-white text-xs font-bold inline-flex items-center gap-1">
          <Plus className="w-3.5 h-3.5" /> Agregar
        </button>
      </div>
    </div>
  );
}
